"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectorConfigurationDriver = exports.hasState = exports.pseudoElementParentSelector = exports.applyState = exports.stripStates = exports.getFinalStateName = exports.getTargetState = void 0;
var native_pseudo_elements_set_1 = require("./utils/native-pseudo-elements-set");
var SELECTOR_STATE_REGEX = /.*[^:]:([^:]*)$/; // TODO: Unify with one from aggregation
var PSEUDO_ELEMENT_OPERATOR = '::';
function getTargetState(selector) {
    var findState = selector.match(/.*[^:]:([^:]+)/);
    if (findState && findState.length > 1) {
        return selector.slice(0, findState[0].length);
    }
    else {
        return selector;
    }
}
exports.getTargetState = getTargetState;
function getFinalStateName(selector) {
    var stateMatch = getTargetState(selector).match(SELECTOR_STATE_REGEX);
    return stateMatch ? stateMatch[1] : '';
}
exports.getFinalStateName = getFinalStateName;
function stripStates(selector) {
    var findState = selector.match(/.*[^:](:[^:]+)/);
    if (findState) {
        return selector.replace(findState[1], '');
    }
    else {
        return selector;
    }
}
exports.stripStates = stripStates;
function applyState(sourceSelector, state, destSelector) {
    return destSelector.startsWith(sourceSelector)
        ? "".concat(sourceSelector).concat(state !== '' ? ':' + state : '').concat(destSelector.replace(sourceSelector, ''))
        : destSelector;
}
exports.applyState = applyState;
function pseudoElementParentSelector(selector) {
    if (!~selector.indexOf(PSEUDO_ELEMENT_OPERATOR)) {
        return selector;
    }
    var splitSelector = selector.split(PSEUDO_ELEMENT_OPERATOR);
    splitSelector.splice(-1, 1);
    return splitSelector.join(PSEUDO_ELEMENT_OPERATOR);
}
exports.pseudoElementParentSelector = pseudoElementParentSelector;
function hasState(selector) {
    return !!getFinalStateName(selector);
}
exports.hasState = hasState;
/**
 * @deprecated this will be removed when switching to config 2.0
 */
var SelectorConfigurationDriver = /** @class */ (function () {
    function SelectorConfigurationDriver(selectorConfigurations, variant, defaultStates) {
        var _this = this;
        this.selectorConfigurations = selectorConfigurations;
        this.defaultStates = {};
        this.selectorToVariant = function (selector) { return selector.replace('.root', _this.variant); };
        this.selectorFromVariant = function (selector) { return selector.replace(_this.variant, '.root'); };
        this.variant = variant;
        if (defaultStates) {
            this.defaultStates = defaultStates;
        }
    }
    Object.defineProperty(SelectorConfigurationDriver.prototype, "configuredSelectors", {
        get: function () {
            return Object.keys(this.selectorConfigurations);
        },
        enumerable: false,
        configurable: true
    });
    /*
    returns the target prime selector for any given rawSelector source. (e.g .button::text -> .button)
     */
    SelectorConfigurationDriver.prototype.getPrimeElement = function (rawSelector, onlyFold) {
        if (onlyFold === void 0) { onlyFold = false; }
        var selectorConfiguration = this.getSelectorConfiguration(rawSelector);
        if (selectorConfiguration !== undefined &&
            selectorConfiguration.primeElementSelector &&
            (!onlyFold || selectorConfiguration.foldInto)) {
            return this.selectorToVariant(selectorConfiguration.primeElementSelector);
        }
        return rawSelector;
    };
    SelectorConfigurationDriver.prototype.getSelectorConfiguration = function (selector) {
        return this.selectorConfigurations[this.selectorFromVariant(selector)];
    };
    SelectorConfigurationDriver.prototype.resolveOverride = function (selector) {
        var selectorConfiguration = this.getSelectorConfiguration(selector);
        if (selectorConfiguration !== undefined) {
            if (selectorConfiguration.primeElementSelector) {
                return this.resolveOverride(selectorConfiguration.primeElementSelector);
            }
            return selectorConfiguration;
        }
        return;
    };
    // public getElementName(selector: string): string {
    //     const override = this.resolveOverride(selector);
    //     return (override && override.nameKey) ? override.nameKey : '';
    // }
    SelectorConfigurationDriver.prototype.getElementStateDisplayKey = function (selector) {
        var override = this.resolveOverride(selector);
        return override && override.stateDisplayKey ? override.stateDisplayKey : '';
    };
    SelectorConfigurationDriver.prototype.isStateHidden = function (selector, state) {
        var override = this.resolveOverride(selector);
        return ((override &&
            override.stateNameOverrides &&
            override.stateNameOverrides[state] &&
            override.stateNameOverrides[state].hidden) ||
            false);
    };
    SelectorConfigurationDriver.prototype.getStateName = function (selector, state) {
        var override = this.resolveOverride(selector);
        return ((override &&
            override.stateNameOverrides &&
            override.stateNameOverrides[state] &&
            override.stateNameOverrides[state].nameKey) ||
            (this.defaultStates[state] && this.defaultStates[state].nameKey) ||
            state);
    };
    /*
    adds the given state to the given selector according to the selector's prime element and returns the resolved selector
     */
    SelectorConfigurationDriver.prototype.getStateOverrideTransformed = function (selector, state) {
        // native pseudos cannot have states so we go to the previous element
        var stateOverride = (0, native_pseudo_elements_set_1.stripNativePseudoFromSelector)(this.getPrimeElement(selector));
        return applyState(stateOverride, state, selector);
    };
    SelectorConfigurationDriver.prototype.getStatesOrder = function (selector) {
        var override = this.resolveOverride(selector);
        return override && override.statesOrder ? override.statesOrder : [];
    };
    SelectorConfigurationDriver.prototype.getCopyControllers = function (selector) {
        var _this = this;
        var foldedCopiedControllers = undefined;
        var foldedIntoSelectors = this.getInheritedStateSelectors(selector, true);
        if (foldedIntoSelectors.length > 0) {
            foldedCopiedControllers = {};
            foldedIntoSelectors.forEach(function (copySelectorVariant) {
                foldedCopiedControllers[copySelectorVariant] = [{}];
            });
        }
        var selectorConfiguration = this.getSelectorConfiguration(selector);
        if (!selectorConfiguration ||
            !selectorConfiguration.copyControllers ||
            Object.keys(selectorConfiguration.copyControllers).length === 0) {
            return foldedCopiedControllers;
        }
        return Object.keys(selectorConfiguration.copyControllers).reduce(function (copyControllers, copySelector) {
            copyControllers[_this.selectorToVariant(copySelector)] =
                selectorConfiguration.copyControllers[copySelector];
            return copyControllers;
        }, foldedCopiedControllers || {});
    };
    SelectorConfigurationDriver.prototype.getInheritedStateSelectors = function (sourceVariantSelector, onlyFold) {
        var _this = this;
        if (onlyFold === void 0) { onlyFold = false; }
        var sourceSelector = this.selectorFromVariant(sourceVariantSelector);
        var inheritedStateSelectors = [];
        this.configuredSelectors.forEach(function (elementSelector) {
            if (elementSelector === sourceSelector) {
                return;
            }
            var primeElementSelector = _this.getPrimeElement(elementSelector, onlyFold);
            if (primeElementSelector === sourceVariantSelector) {
                inheritedStateSelectors.push(_this.selectorToVariant(elementSelector));
            }
        });
        return inheritedStateSelectors;
    };
    return SelectorConfigurationDriver;
}());
exports.SelectorConfigurationDriver = SelectorConfigurationDriver;
//# sourceMappingURL=selector-configuration-driver.js.map